// Generated by scripts/build-ui-icons.mjs.
export { LockKey as default } from "../ui/glyphs-5";
